module.exports = __webpack_public_path__ + "static/media/loading.0e2358c3.gif";